import { render } from "./PersonalInfo.vue?vue&type=template&id=2ca8992c&scoped=true&ts=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=ts"
export * from "./PersonalInfo.vue?vue&type=script&lang=ts"

import "./PersonalInfo.vue?vue&type=style&index=0&id=2ca8992c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca8992c"]])

export default __exports__